export default [
    {
        // [0]
        key: "department",
        label: app.$i18n.t("Department"),
        visible: true
    },
    {
        // [1]
        key: "business_name",
        label: app.$i18n.t("Client"),
        visible: true
    },
    {
        // [2]
        key: "service_type",
        label: app.$i18n.t("Service Type"),
        visible: true
    },
    {
        // [3]
        key: "travel_route",
        label: app.$i18n.t("Route"),
        visible: true
    },
    {
        // [4]
        key: "setting_vehicle",
        label: app.$i18n.t("Setting Vehicle"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [5]
        key: "measure_type",
        label: app.$i18n.t("Measure Type"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [6]
        key: "amount",
        label: app.$i18n.t("Amount"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [7]
        key: "province",
        label: app.$i18n.t("Provinces"),
        visible: true
    },
    {
        // [8]
        key: "origin_route",
        label: app.$i18n.t("Origin"),
        visible: true
    },
    {
        // [9]
        key: "destination_route",
        label: app.$i18n.t("Destination"),
        visible: true
    },
    {
        // [10]
        key: "zone",
        label: app.$i18n.t("Zones"),
        visible: true
    },
    {
        // [11]
        key: "code",
        label: app.$i18n.t("Code"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [12]
        key: "district",
        label: app.$i18n.t("Districts"),
        visible: true
    },
    {
        // [13]
        key: "location",
        label: app.$i18n.t("Location"),
        visible: true
    },
    {
        // [14]
        key: "tolls",
        label: app.$i18n.t("Tolls"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [15]
        key: "total_amount_tolls",
        label: app.$i18n.t("Amount tolls"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [16]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [17]
        key: "actions",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    }
]